import gql from 'graphql-tag'

export const SYSTEM_USER_REPORT = gql`
    query($input: ReportBySystemUserInput!) {
        reportBySystemUser(input: $input)
    }
`
